 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"legacy/main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"js/ProductSampleModalToggle":"js/ProductSampleModalToggle","js/legacy/Accordion":"js/legacy/Accordion","js/legacy/AddToCart":"js/legacy/AddToCart","js/legacy/AddressForm":"js/legacy/AddressForm","js/legacy/AjaxModal":"js/legacy/AjaxModal","js/legacy/AjaxModalButton":"js/legacy/AjaxModalButton","js/legacy/Alert":"js/legacy/Alert","js/legacy/BackToTop":"js/legacy/BackToTop","js/legacy/BackgroundgroundLight":"js/legacy/BackgroundgroundLight","js/legacy/BasicSlider":"js/legacy/BasicSlider","js/legacy/BookAnAppointmentForm":"js/legacy/BookAnAppointmentForm","js/legacy/Chat":"js/legacy/Chat","js/legacy/ConditionalShippingMethods":"js/legacy/ConditionalShippingMethods","js/legacy/ContactForm":"js/legacy/ContactForm","js/legacy/ContactFormEmail":"js/legacy/ContactFormEmail","js/legacy/Countdown":"js/legacy/Countdown","js/legacy/CouponForm":"js/legacy/CouponForm","js/legacy/CreateAccountForm":"js/legacy/CreateAccountForm","js/legacy/CustomSelectBox":"js/legacy/CustomSelectBox","js/legacy/DisabledElement":"js/legacy/DisabledElement","js/legacy/DownloadBase64Pdf":"js/legacy/DownloadBase64Pdf","js/legacy/Dropdown":"js/legacy/Dropdown","js/legacy/EditEmailForm":"js/legacy/EditEmailForm","js/legacy/EditPasswordForm":"js/legacy/EditPasswordForm","js/legacy/EditProfileForm":"js/legacy/EditProfileForm","js/legacy/FancyList":"js/legacy/FancyList","js/legacy/FormFieldsToggle":"js/legacy/FormFieldsToggle","js/legacy/GTMEvents":"js/legacy/GTMEvents","js/legacy/Header":"js/legacy/Header","js/legacy/HighResImageGallery":"js/legacy/HighResImageGallery","js/legacy/IconListCarousel":"js/legacy/IconListCarousel","js/legacy/ImageModal":"js/legacy/ImageModal","js/legacy/ImageZoom":"js/legacy/ImageZoom","js/legacy/InputSync":"js/legacy/InputSync","js/legacy/LabelAsPlaceholder":"js/legacy/LabelAsPlaceholder","js/legacy/LanguageSelector":"js/legacy/LanguageSelector","js/legacy/MegaMenu":"js/legacy/MegaMenu","js/legacy/Minicart":"js/legacy/Minicart","js/legacy/MobileNavigation":"js/legacy/MobileNavigation","js/legacy/Modal":"js/legacy/Modal","js/legacy/NavigationBar":"js/legacy/NavigationBar","js/legacy/NewPasswordForm":"js/legacy/NewPasswordForm","js/legacy/NewsletterForm":"js/legacy/NewsletterForm","js/legacy/NotificationForm":"js/legacy/NotificationForm","js/legacy/OrderHistoryRefinement":"js/legacy/OrderHistoryRefinement","js/legacy/Page":"js/legacy/Page","js/legacy/PagedNavigation":"js/legacy/PagedNavigation","js/legacy/Pagination":"js/legacy/Pagination","js/legacy/ProductAttribute":"js/legacy/ProductAttribute","js/legacy/ProductAttributeSize":"js/legacy/ProductAttributeSize","js/legacy/ProductDetail":"js/legacy/ProductDetail","js/legacy/ProductDetailHero":"js/legacy/ProductDetailHero","js/legacy/ProductRangeSlider":"js/legacy/ProductRangeSlider","js/legacy/ProductSampleForm":"js/legacy/ProductSampleForm","js/legacy/ProductTileButton":"js/legacy/ProductTileButton","js/legacy/ProfessionalTrigger":"js/legacy/ProfessionalTrigger","js/legacy/PromotionBanner":"js/legacy/PromotionBanner","js/legacy/QuantitySelector":"js/legacy/QuantitySelector","js/legacy/RefinementFilter":"js/legacy/RefinementFilter","js/legacy/Refinements":"js/legacy/Refinements","js/legacy/RegisterForm":"js/legacy/RegisterForm","js/legacy/RemoveAddress":"js/legacy/RemoveAddress","js/legacy/RemoveCoupon":"js/legacy/RemoveCoupon","js/legacy/RemoveProduct":"js/legacy/RemoveProduct","js/legacy/ResetPasswordForm":"js/legacy/ResetPasswordForm","js/legacy/ScrollGradient":"js/legacy/ScrollGradient","js/legacy/ScrollIntoView":"js/legacy/ScrollIntoView","js/legacy/Search":"js/legacy/Search","js/legacy/SetCookieOnClick":"js/legacy/SetCookieOnClick","js/legacy/ShippingForm":"js/legacy/ShippingForm","js/legacy/ShowRefinementFilters":"js/legacy/ShowRefinementFilters","js/legacy/SigninForm":"js/legacy/SigninForm","js/legacy/SkipLink":"js/legacy/SkipLink","js/legacy/SortSelectBox":"js/legacy/SortSelectBox","js/legacy/TabNav":"js/legacy/TabNav","js/legacy/Toggle":"js/legacy/Toggle","js/legacy/TogglePassword":"js/legacy/TogglePassword","js/legacy/Tooltip":"js/legacy/Tooltip","js/legacy/Video":"js/legacy/Video","js/legacy/Video-Platforms":"js/legacy/Video-Platforms","js/legacy/adyen-payment":"js/legacy/adyen-payment","js/legacy/billing-form":"js/legacy/billing-form","js/legacy/payflow-billing-form":"js/legacy/payflow-billing-form","js/legacy/Vimeo-Player":"js/legacy/Vimeo-Player"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
